import React, { useEffect, useState, useContext } from "react";
import "@dotlottie/player-component";
import AnimatedCursor from "react-animated-cursor";
import "swiper/css";
import "swiper/css/effect-fade";
import { Link } from "react-router-dom";
import thank from "../../../assets/img/lp/thank.svg";
import { isMobile } from "detect-touch-device";
import axios from "axios";
import { headersConfig, basicAuthConfig } from "../../../config/constants";
import mainContext from "../../../config/mainContext";
import { useLocation, useNavigate } from "react-router-dom";

const { REACT_APP_ASSET_URL } = process.env;

const LPThank = () => {
  const { appToken } = useContext(mainContext);
  const [count, setCount] = useState(10);
  const [redirectUrl, setRedirectUrl] = useState(
    "https://webapp.slice.ooo/sign-up"
  );
  const location = useLocation();
  const navigate = useNavigate();
  const formData = location.state;

 //   alert(JSON.stringify(formData));

  const getRedirectionUrl = async () => {
   // if (!appToken) return;

    try {
      const response = await axios.post(
        "https://api.slice.ooo/main/slice/api/v1/user/redirect-to-signup",
        {
          firstName: formData.formData.firstName,
          lastName: formData.formData.lastName,
          email: formData.formData.email,
        },
        {
          headers: {
            ...headersConfig,
            ...basicAuthConfig
          },
        }
      );

      if (response?.data?.data?.redirectUrl) {
        setRedirectUrl(response.data.data.redirectUrl);
      }
    } catch (error) {
      console.error("Failed to fetch redirect URL:", error);
    }
  };


  useEffect(() => {

      getRedirectionUrl();
    
  }, [appToken]);


  useEffect(() => {
    if (count > 0) {
      const timer = setTimeout(() => setCount((prev) => prev - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      window.location.href = redirectUrl;
    }
  }, [count, redirectUrl]);


  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-17549939087/6y0xCL6F-7UbEI-ju7BB",
      });
    }

    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: 6527090, hjsv: 6 };
      a = o.getElementsByTagName("head")[0];
      r = o.createElement("script");
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
  }, []);

  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      {/* ✅ Minimal header just for logo */}
      <header id="header" className="sticky">
        <div className="header-box">
          <div className="head-left">
            <div className="logoBox">
              <Link className="logo" to="/" onClick={() => window.scrollTo(0, 0)}>
                <img src={`${REACT_APP_ASSET_URL}/logo.svg`} alt="Logo" />
              </Link>
            </div>
          </div>
        </div>
      </header>

      <main className="cursorNo">
        <section className="thankPag">
          <div className="container">
            <div className="f-roe">
              <div className="f-col text-center">
                <figure className="mb-2">
                  <img src={thank} alt="people" />
                </figure>
                <h1 className="fs-1">Thank You! </h1>
              </div>
              <div className="f-col text-center">
                <p className="fs-4">We are excited to have you explore Slice!</p>
                <p className="fs-7">
                  You’re just a few steps away from starting your real estate
                  investment journey:
                </p>
              </div>

              <div className="formBox w70 w-768-100 my-auto">
                <ul className="f-row f-3 f-990-1 change-cursor">
                  <li className="f-col">
                    <div>
                      <strong>1</strong>
                    </div>
                    <p>Create your Slice account (it’s free)</p>
                  </li>
                  <li className="f-col">
                    <div>
                      <strong>2</strong>
                    </div>
                    <p>Complete quick KYC verification</p>
                  </li>
                  <li className="f-col">
                    <div>
                      <strong>3</strong>
                    </div>
                    <p>Fund your wallet & explore opportunities</p>
                  </li>
                </ul>
              </div>

              <div className="f-col text-center contBeg">
                <div className="w60 my-auto w-768-100">
                  <p className="fs-7">
                    Begin today and unlock access to fractionalised, DFSA-regulated
                    real estate investing from just $100
                  </p>
                </div>
                <Link to={redirectUrl} className="butSta">
                  <span> Start Onboarding Now</span>
                </Link>

                <p className="fs-5">
                  Redirecting you to our secure sign-up page to begin your
                  onboarding... <strong>{count}</strong>
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* ✅ Footer remains same */}
      <footer className="footer-wrap change-cursor">
        <div className="container change-cursor">
          <div className="footer-box change-cursor">
            <div className="footer-top change-cursor">
              <div className="f-row change-cursor flex-center">
                <div className="w80 w-768-100 footer-logo-wrap change-cursor text-center">
                  <div className="logo footer-logo change-curso ">
                    <img
                      src={`${REACT_APP_ASSET_URL}/slice-logo-white.svg`}
                      alt="Logo"
                    />
                  </div>
                  <p className="footer-txt change-cursor">
                    This platform is incorporated in the Dubai International
                    Financial Centre (DIFC) and regulated by the Dubai Financial
                    Services Authority (DFSA). Investments are made via Special
                    Purpose Vehicles (SPVs). Investing in real estate carries risk.
                    Returns are not guaranteed, and investors may lose part or all
                    of their capital. Past performance is not a reliable indicator
                    of future results.
                  </p>
                </div>
              </div>
            </div>

            <div className="footer-bottom change-cursor text-center d-column">
              <div className="footer-list social-list change-cursor mb-4">
                <ul>
                  <li>
                    <a
                      href="https://www.instagram.com/slicesuperapp/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={`${REACT_APP_ASSET_URL}/common/insta.svg`}
                        alt=""
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.facebook.com/SliceSuperApp"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="icon-facebook" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/Slicesuperapp"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={`${REACT_APP_ASSET_URL}/common/twitter.svg`}
                        alt=""
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/slice-fintech/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={`${REACT_APP_ASSET_URL}/linkedin-logo.svg`}
                        alt=""
                      />
                    </a>
                  </li>
                </ul>
              </div>
              <div className="terms-pages change-cursor termsPages">
                <Link
                  to="/faq?data=RiskDisclosures"
                  target="_blank"
                  className="curzr-hover change-cursor"
                  onClick={handleLinkClick}
                >
                  Key Risk
                </Link>
                <Link
                  to="/terms-condition"
                  target="_blank"
                  className="curzr-hover change-cursor"
                  onClick={handleLinkClick}
                >
                  Terms & Conditions
                </Link>
                <Link
                  to="/privacy-policy"
                  target="_blank"
                  className="curzr-hover change-cursor"
                  onClick={handleLinkClick}
                >
                  Privacy Policy
                </Link>
              </div>

              <p className="footer-txt w100 ">
                {new Date().getFullYear()} Slice. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {!isMobile && (
        <AnimatedCursor
          innerSize={0}
          outerSize={25}
          innerScale={1}
          outerScale={1.7}
          outerAlpha={0}
          trailingSpeed={1}
          outerStyle={{
            border: "2px solid rgba(67, 37, 245, 1)",
            background: "rgba(67, 37, 245, 0.5)",
            mixBlendMode: "difference",
          }}
        />
      )}
    </>
  );
};

export default LPThank;
